const RegularExpressions = {
  NumbersOnly: /^[0-9\b]+$|^$/,
  PositiveNegativeNumbers: /^-?\d+$/,
  PositiveNegativeNumbersWithDecimal: /^[+-]?[0-9]+(?:\.[0-9]+)?$/,
};

export default RegularExpressions;
